import { render, staticRenderFns } from "./ShowFormItem.vue?vue&type=template&id=6aa986ed&"
import script from "./ShowFormItem.vue?vue&type=script&lang=js&"
export * from "./ShowFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports